import styled from 'styled-components';
import bgImage from "assets/images/bg.png";
import { theme } from '@theme';
import { Link } from "react-router-dom";
import { Typography } from "@atoms";

export const HeaderContainer = styled.header<{ isHome?: boolean }>`
  -webkit-tap-highlight-color: transparent;
  position: fixed;
  top: 0;
  left: 80px;
  right: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
  border-bottom: 1px solid #E4D7CD;
  background: ${({ isHome }) => (isHome ? '#F2EBE6' : `url(${bgImage}) no-repeat center center fixed`)};
  background-size: cover;
  z-index: 9;

  @media screen and (max-width: ${theme.breakpoints.lg}) {
    padding: 0;
    left: 20px;
    right: 20px;
  }
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 0 16px;
    left: 0;
    right: 0;
    z-index: 9999;
  }
`;

export const Nav = styled.nav`
  display: flex;
  gap: 20px;

  div {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 32px 16px;
  }

  h4 {
    color: #391D0A;
    font-size: 16px;
    font-weight: 400;
    padding: 18px;

    &:hover {
      color: #C6A691;
    }
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    padding: 20px 0;
    gap: 0;
  }
`;

export const StyledLink = styled(Link)`
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  text-decoration: none;

  &:active, &:hover, &:visited {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
  }
`

export const Profile = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  .profile-name {
    font-size: 16px;
    color: #333;
  }

  .profile-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #fff;
  }

  .unLogin {
    height: 40px;
    
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      font-family: Inter;
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      height: 36px;
    }
  }
`;

export const Logout = styled.button`
  display: flex;
  margin-left: 6px;
  cursor: pointer;
  background: none;
  border: none;
  color: #C6A691;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    margin-left: auto;
  }
  
  &:active {
    color: #B2876B;
  }
`

export const Candle = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  border: 1px solid #E4D7CD;
  border-radius: 999px;
  gap: 6px;
  color: #4F473A;

  span {
    color: rgba(79, 71, 58, 0.4);
    margin-right: 10px;
  }
`

export const SidebarFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
`

export const MediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  p {
    color: rgba(57, 29, 10, 1);
  }
`

export const MediaIcons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

export const MediaIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  
  width: 32px;
  height: 32px;
  
  background: rgba(198, 166, 145, 1);
  border-radius: 4px;
`

export const StyledLinkFooter = styled(Link)`
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: rgba(189, 152, 127, 1);
  text-decoration: none;

  &:active, &:hover {
    color: rgba(198, 166, 145, 1);
  }

  &:active, &:hover, &:visited {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
  }
`

export const Copyright = styled(Typography)`
  margin-top: 8px
`

export const LegalInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
  padding: 16px;
  
  p {
    color: rgba(89, 78, 71, 0.7);
  }
`
